import React , { createContext, useContext, useReducer } from "react";
import PropTypes from "prop-types";
import { initailState as profileState  } from "./utils/profileReducer";




const Profilecontext = createContext(profileState);
/**
 * 
 * @returns {[profileState , function(import('./utils/profileReducer').ActionType):void ] }
 */
export const useProfilecontext = () => useContext(Profilecontext);



/**
 * 
 * @param {Object} props
 * @param {profileState} props.initailState
 * @returns 
 */

function Profileprovider({ children, initailState, reducer }) {
    return (<Profilecontext.Provider value={useReducer(reducer, initailState)}>
        {children}
    </Profilecontext.Provider>
    );
}
  

Profileprovider.propTypes ={
    initailState:profileState
}



export default Profileprovider